export const LISTINGS_ANALYTICS_EVENTS = {
  LAYOUT_CHANGED: 'listings_layout_changed',
  GRID_EXPORTED: 'listings_grid_exported',
  IMPORT_BATCH_STARTED: 'listing_import_batch_started',
} as const;
